<template>
    <div class="footer-wrapper">
      <!-- Main footer content -->
      <div class="footer-main">
        <!-- Left side logos -->
        <div class="logo-container">
          <div class="lab-logo">
            <img src="/in-logo4.png" alt="Key Laboratory of Data Science in Finance and Economics" />
          </div>
          <!-- <div class="university-logo">
            <img src="/logo.png" alt="Jiangxi University of Finance and Economics" />
          </div> -->
        </div>
        
        <!-- Vertical divider -->
        <div class="vertical-divider"></div>
        
        <!-- Right side addresses -->
        <div class="address-container">
          <div class="address-item">蛟桥园校区：江西省南昌市昌北国家经济技术开发区双港东大街169号 邮编：330013</div>
          <div class="address-item">青山湖校区：南昌市青山南大道596号 邮编：330077</div>
          <div class="address-item">麦庐园校区：江西省南昌市昌北国家经济技术开发区玉屏大道 邮编：330032</div>
          <div class="address-item">枫林园校区：江西省南昌市昌北国家经济技术开发区枫林大道632号 邮编：330013</div>
        </div>
        
        <!-- Friendly links dropdown -->
        <div class="friendly-links">
          <div class="dropdown">
            <!-- <button class="dropdown-button">
              友情链接
              <i class="dropdown-icon">▼</i>
            </button> -->
          </div>
        </div>
      </div>
      
      <!-- Copyright footer -->
      <div class="copyright-footer">
        Copyright@ 2011-2026 江西财经大学财经数据科学教育部哲学社会科学实验室（培育） All Rights Reserved
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PageFooter'
  }
  </script>
  
  <style scoped>
  .footer-wrapper {
    width: 100%;
    font-family: Arial, sans-serif;
  }
  
  .footer-main {
    display: flex;
    align-items: center;
    padding: 20px 0;
    background-color: #3674b1;
    color: white;
    position: relative;
  }
  
  .logo-container {
    display: flex;
    align-items: end;
    margin-top: -10px;
    margin-left: 10px;
    margin-right: 10px;
    width: 50%;
    padding-left: 40px;
  }
  
  .lab-logo {
    width: 500px;
    margin-right: 30px;
    margin-left: 170px;
  }

  .university-logo img {
   width: 400px;
  }
  
  .vertical-divider {
    height: 170px;
    width: 1px;
    background-color: #99b9c4;
    margin: 0 15px 0 9%;
    z-index: 999;
  }
  
  .address-container {
    display: flex;
    flex-direction: column;
    width: 55%;
    height: 100%;
    margin-top: 10px;
    margin-left: 1%;
    padding: 30px;
  }
  
  .address-item {
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 100;
  }
  
  .friendly-links {
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
  }
  
  .dropdown {
    position: relative;
    display: inline-block;
  }
  
  .dropdown-button {
    display: flex;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }
  
  .dropdown-icon {
    margin-left: 6px;
    font-size: 10px;
  }
  
  .copyright-footer {
    background-color: #2a5463;
    color: white;
    text-align: center;
    padding: 12px 0;
    font-size: 14px;
  }
  
  @media (max-width: 992px) {
    .footer-main {
      flex-direction: column;
      padding: 20px;
    }
    
    .logo-container, .address-container {
      width: 100%;
      padding-left: 0;
      margin-bottom: 15px;
    }
    
    .vertical-divider {
      display: none;
    }
    
    .friendly-links {
      position: static;
      transform: none;
      margin-top: 15px;
    }
  }
  </style>